import { set } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import { fetchOutreachAggregateOptions } from '../../../sagas/report/routines';

const initialState = {
  locations: [],
  trackingMethods: [],
  fetching: false,
  fetched: false,
  fetchingError: null
};

const fetchOutreachAggregateOptionsHandler = routine => ({
  [routine.TRIGGER]: set('fetching', true),
  [routine.SUCCESS]: (state, { payload: { response } }) => ({
    ...state,
    ...response
  }),
  [routine.FAILURE]: (state, { error }) => set('fetchingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

export default createReducer(initialState, {
  ...fetchOutreachAggregateOptionsHandler(fetchOutreachAggregateOptions)
});
